import React from 'react';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';
import { useController, useForm, useFormContext } from 'react-hook-form';
import { ConvertBooleanToString } from '../Formatters/ConvertBoolean';

export default function CheckboxInput(props) {

  const { name, onChange, errors, label, helperText, labelClassName, onBlur, isValueString, inputRef, ...checkboxProps } = props;
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm;
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control
  });

  const handleChange = (option) => {
    field.onChange(isValueString ? ConvertBooleanToString(option.target.checked) : option.target.checked)
    onChange && onChange(option)
  }

  const handleBlur = (event) => {
    field.onBlur(); // Ensures react-hook-form validation runs
    onBlur && onBlur(event); // Calls parent onBlur if provided
  };

  return (
    <FormControl error={!!errors} className='checkbox-input'>
      <FormControlLabel
        control={
          <Checkbox
            {...checkboxProps}
            onChange={handleChange}
            onBlur={handleBlur}
            color="primary"
          />
        }
        label={label}
        className={labelClassName}
      />
      <FormHelperText>{helperText}</FormHelperText>
      <FormHelperText className={error ? 'Mui-error' : ''}>{error?.message}</FormHelperText>
    </FormControl>
  )
}

CheckboxInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  inputRef: PropTypes.func,
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  errors: PropTypes.object,
  helperText: PropTypes.string,
};
